import React from "react";

const ToastError = ({ error }) => {
  console.log(error, "terst");
  return (
    <div
      id="toast-error"
      className={`flex items-center w-full max-w-sm p-4 text-white bg-secondary rounded-lg shadow-lg fixed top-50 animate-bounce left-[45%] z-50`}
      role="alert"
    >
      <div className="inline-flex items-center justify-center shrink-0 w-8 h-8 text-red-500 bg-blue-100 rounded-lg">
        <svg
          className="w-3 h-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
          />
        </svg>
      </div>
      <div className="ms-3 text-sm font-normal">{error}</div>
    </div>
  );
};

export default ToastError;
